import { VStack, IconStatusNew, HStack, Text } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { FixedFeeRelatedTermContentProps } from '.';

export const FixedFeeRelatedTermDesktop: React.FC<FixedFeeRelatedTermContentProps> = ({
  relatedTerm,
}) => {
  return (
    <HStack
      p="inset.xs"
      backgroundColor="backgroundshade"
      justifyContent="space-between"
      borderBottomRadius={BoxRadius.sm}>
      <VStack space="stack.quarck">
        <Text color="neutral.medium" fontSize="xs">
          Termo relacionado
        </Text>
        <VStack>
          <Text>{relatedTerm.term}</Text>
          <IconStatusNew
            color={relatedTerm.statusColor}
            icon={relatedTerm.statusIcon}
            status={relatedTerm.status}
          />
        </VStack>
      </VStack>
      <VStack space="stack.quarck">
        <Text color="neutral.medium" fontSize="xs">
          Iniciado em
        </Text>
        <Text>{relatedTerm.contractDateNormalized}</Text>
      </VStack>
    </HStack>
  );
};
